import { render, staticRenderFns } from "./ChipFomList.vue?vue&type=template&id=0474c80c&scoped=true&"
import script from "./ChipFomList.ts?vue&type=script&lang=ts&"
export * from "./ChipFomList.ts?vue&type=script&lang=ts&"
import style0 from "./ChipFomList.scss?vue&type=style&index=0&id=0474c80c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474c80c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
